import { makeStyles } from '@material-ui/core/';

export default makeStyles(({ palette }) => ({
  remove: {
    backgroundColor: palette.error.main,
  },
  content: {
    fontWeight: 700,
  },
  button: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    padding: '0',
  },
  buttonContainer: {
    height: '50px',
    width: '100%',
  },
  spinner: {
    opacity: 0.3,
    color: palette.common.white,
  },
}));
